
 import { authenticatedFetch } from "../Auth/Auth";
 import { getCurrentConfig } from '../../config/config';
 
 const config = getCurrentConfig();

export const updateContact = async (contactJSONbody) => {
   
 
    const response = await authenticatedFetch(`${config.API_BASE_URL}/contacts`, {
        method: 'PUT',
        headers: {
        
          'Content-Type': 'application/json',
          'User-Agent': 'agentApp/1.0',
        },
        body: JSON.stringify(contactJSONbody)
      });
      
      if (response.ok) {
        const responseData = await response.json();
        return responseData;
      } else {
        throw new Error(`Error updating contact`);
      }




};